/**
 * Renka (application_id 76) のテーマカラー。蓮花 / purple 系。
 * base = purple-500 / 600、accent = fuchsia-400 のグラデーション。
 *
 * Renka は国内 (JP) 配信限定のため、JP 以外の言語環境では bootstrapTheme 側で
 * DEFAULT_PALETTE にフォールバックさせる（Utage-Web の運用に合わせる）。
 */
import { tailwindScales as tw } from "../tailwindColors";
import type { ThemePalette } from "../types";

export const RENKA_PALETTE: ThemePalette = {
  appId: "76",
  appName: "Renka",
  cyan: tw.purple,
  teal: tw.fuchsia,
  gradient: { from: tw.purple[500], to: tw.fuchsia[400] },
  ink: { base: "#1F0A33", soft: "#5B3F7A", mute: "#9387A8" },
  app: { bg: "#FAF5FF", card: "#FFFFFF" },
};
